interface FileIconProps {
  size?: number;
}

export default function FileIcon({ size = 14 }: FileIconProps) {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={size} 
      height={(size * 17) / 14} 
      viewBox="0 0 14 17" 
      fill="none"
    >
      <path 
        fillRule="evenodd" 
        clipRule="evenodd" 
        d="M6.66667 0V5.41667C6.66667 5.74819 6.79836 6.06613 7.03278 6.30055C7.2672 6.53497 7.58515 6.66667 7.91667 6.66667H13.3333V15C13.3333 15.442 13.1577 15.8659 12.8452 16.1785C12.5326 16.4911 12.1087 16.6667 11.6667 16.6667H1.66667C1.22464 16.6667 0.800716 16.4911 0.488155 16.1785C0.175595 15.8659 0 15.442 0 15V1.66667C0 1.22464 0.175595 0.800716 0.488155 0.488155C0.800716 0.175595 1.22464 0 1.66667 0H6.66667ZM5.8425 8.20667C5.64302 9.47588 4.97927 10.6258 3.98 11.4333C3.24083 12.03 3.91667 13.2008 4.80333 12.86C6.00235 12.3982 7.33015 12.3982 8.52917 12.86C9.41583 13.2017 10.0917 12.0308 9.3525 11.4333C8.35322 10.6258 7.68948 9.47588 7.49 8.20667C7.3425 7.26833 5.99 7.2675 5.8425 8.20667ZM6.66667 10.2525L7.33833 11.4142H5.99667L6.66667 10.2525ZM8.33333 0.0358333C8.64907 0.102796 8.93856 0.259993 9.16667 0.488333L12.845 4.16667C13.0733 4.39477 13.2305 4.68427 13.2975 5H8.33333V0.0358333Z" 
        fill="currentColor"
      />
    </svg>
  );
}
